import React from "react";
import { useSelector } from "react-redux";
import { getSourceSystemContent } from "../../store/selectors";

export default function InitialOfferSkeletonLoader() {
  const {
    initialOfferContent: { renderImageUpload }
  } = useSelector(getSourceSystemContent);
  return (
    <div className="loading-container ch-ml--auto ch-mr--auto">
      <div className="ch-width--12 loading-info-container">
        {renderImageUpload && (
          <div className="ch-display--flex ch-width--12">
            <div className="loading-image ch-skeleton ch-circle" />
            <div className="ch-ml--1">
              <div className="loading-reg ch-mb--2 ch-skeleton" />
              <div className="loading-price ch-skeleton" />
            </div>
          </div>
        )}
        <div className="loading-guarantee ch-mt--2 ch-skeleton ch-width--12" />
      </div>
    </div>
  );
}
